<script>
import _ from 'lodash'
import {
  questionPageMethods,
  assessmentRunSessionMethods,
  userAnswerMethods,
  locationsMethods,
  organizationChartMethods,
} from '@state/helpers'
import { mapGetters } from 'vuex'
// import InputSelect from '@components/form/InputSelect'
import InputTextarea from '@components/form/InputTextarea'
import InputText from '@components/form/InputText'
// import InputCheckbox from '@components/form/InputCheckbox'
import CustomMultiselect from '@components/form/customMultiselect'
import InputDate from '@components/form/InputDate'
// import SurveyHeader from './survey-header.vue'
export default {
  name: 'QuestionsComponent',
  components: {
    InputText,
    // InputCheckbox,
    // InputSelect,
    InputTextarea,
    CustomMultiselect,
    InputDate,
    // CustomMultiselect,
    // SurveyHeader,
  },

  props: {
    assessment: {
      type: Object,
      required: true,
    },
    currentUser:{
      type: Object,
      required: false,
    },
    initialValue:{
      type:String,
      required:false,
      default:null
    },
    isFirst:{
      type:Boolean,
      required:false
    },
    currentForm: {
      type: Object,
      default: () => {},
    },
    pageData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loadingPageData: false,
      municipalitySelected: null,
      positionSelected: null,
      inputHiddenString: '',
      modalDeleteAllIntraocupational:false,
      // antAnswer:null
    }
  },

  computed: {
    ...mapGetters({
      assessmentRunSession:
        'assessment/assessmentRunSession/assessmentRunSession',
      municipalitiesOptions: 'company/locations/municipality',
      organizationChartOptions:
        'assessment/organizationChart/organizationCharts',
      userAnswers: 'assessment/userAnswer/userAnswers',
    }),
  },

  watch: {
    pageData() {
      this.municipalitySelected = null
      this.inputHiddenString = ''
    },

    userAnswers(val) {
      if (!val.count) return
      this.setSelectedOptionsAnswers()
    },

    municipalitySelected(value) {
      if (!value) return
      const question = this.pageData.questions_details.find(
        (el) => el.formfieldtype_info.name === 'select_ciudad'
      )
      if (question) {
        this.currentForm[question.id] = value.id
      }
    },

    positionSelected(value) {
      if (!value) return
      const question = this.pageData.questions_details.find(
        (el) => el.formfieldtype_info.name === 'select_cargo'
      )
      if (question) {
        this.currentForm[question.id] = value.id
        const question2 = this.pageData.questions_details.find(
          (el) => el.formfieldtype_info.name === 'oculto'
        )
        if (question2) {
          this.currentForm[question2.id] = value.area_detail.id
          this.inputHiddenString = `${value.area_detail.type_display} ${value.area_detail.name}`
        }
      }
    },
  },

  mounted() {
    this.fetchLocations({ type: 'municipality' })
    this.getOrganizationChart()
  },

  methods: {
    ...questionPageMethods,
    ...assessmentRunSessionMethods,
    ...userAnswerMethods,
    ...locationsMethods,
    ...organizationChartMethods,
    async getOrganizationChart() {
      const { error } = await this.fetchOrganizationCharts(
        `?assessment_id=${this.assessment.id}&page_size=999`
      )
      if (error) {
        this.$axios_error_noty(error, this)
      }
    },

    setSelectedOptionsAnswers() {
      if (!this.userAnswers.count) return
      this.userAnswers.results.forEach((el) => {
        if ([9, 13].includes(el.question_detail.id)) {
          this.setMunicipality(_.toInteger(el.answer))
        }
        if ([15].includes(el.question_detail.id)) {
          this.setPosition(_.toInteger(el.answer))
        }
      })
    },

    setMunicipality(answer) {
      if (this.municipalitiesOptions.results) {
        this.municipalitySelected = this.municipalitiesOptions.results.find(
          (el) => el.id === answer
        )
      }
    },

    setPosition(answer) {
      if (this.organizationChartOptions.results) {
        const position = this.organizationChartOptions.results.find(
          (el) => el.id === answer
        )
        this.positionSelected = position
        this.inputHiddenString = `${position.area_detail.type_display} ${position.area_detail.name}`
      }
    },

    getOptions(options) {
      return options.map((option) => ({ id: option.id, text: option.text }))
    },

    getModelOptions(model) {
      switch (model) {
        case 'municipality':
          return this.municipalitiesOptions.results
        case 'position':
          return this.organizationChartOptions.results
        default:
          return []
      }
    },

    getInputType({ id }) {
      if ([2, 12, 14, 20].includes(id)) {
        return 'number'
      }
      return 'text'
    },
    changeSelect(){
      if(this.currentUser.state == 5){
          if(!this.isFirst){
            this.pageData.questions_details.forEach(x=>{
              if(x.id == 16){
                if(this.currentForm[x.id]!==null){
                  if(parseInt(this.initialValue)==35 || parseInt(this.initialValue)==36){
                    if(this.currentForm[x.id] != 35 && this.currentForm[x.id] != 36){
                        this.modalDeleteAllIntraocupational = true
                    }
                  }else if(parseInt(this.initialValue)==33 || parseInt(this.initialValue)==34){
                    if(this.currentForm[x.id] != 33 && this.currentForm[x.id] != 34){
                        this.modalDeleteAllIntraocupational = true
                    }
                  }
                }
              }
            })
          }
      }
    },
    DeleteAllIntraocupationalMethod(){
      this.deleteAllQuestion({assessment_run_session_id:this.currentUser.id})
    },
    CancelDeleteAllIntraocupationalMethod(){
      $bvModal.hide('modal-delete')
    }
  },
}
</script>

<template>
  <div>
    <div>
      <b-modal 
      id="modal-delete"
      v-model="modalDeleteAllIntraocupational" 
      @ok="DeleteAllIntraocupationalMethod"
      title="¿Seguro que desea cambiar la respuesta?">
      <p>Al Cambiar esta respuesta se borrarán los datos del formulario intralaboral ¿Está segur@ que quiere modificar su respuesta?</p>
      </b-modal>
      <!--
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button size="sm" variant="success" @click="DeleteAllIntraocupationalMethod">
          OK
        </b-button>
        <b-button size="sm" variant="danger" @click="CancelDeleteAllIntraocupationalMethod">
          Cancel
        </b-button>
      </template>
      -->
    </div>
    <div v-if="loadingPageData" class="text-center my-4">
      <b-spinner class="align-middle mr-1"></b-spinner>
      <strong>Cargando</strong>
    </div>
    <div v-else>
      <b-container>
        <!-- <div>
          <SurveyHeader :page-id="pageData.id" />
        </div> -->
        <b-row class="d-flex flex-column col-md-12 col-lg-12 mx-auto">
          <div
            v-for="(question, index) in pageData.questions_details"
            :key="index"
          >
            <InputText
              v-if="question.formfieldtype_info.html_element === 'input_text'"
              v-model="currentForm[question.id]"
              validate="required"
              :type="getInputType(question)"
              :name="question.question_number.toString()"
              :label="`${
                question.question_number > 0
                  ? `${question.question_number}.`
                  : ''
              } ${question.spanish_question}`"
            >
            </InputText>

            <InputTextarea
              v-else-if="
                question.formfieldtype_info.html_element === 'textarea'
              "
              :label="`${question.question_number}. ${question.spanish_question}`"
            >
            </InputTextarea>
            <!-- <InputSelect
              v-else-if="question.formfieldtype_info.html_element === 'select'"
              v-model="currentForm[question.id]"
              :name="question.id.toString()"
              :label="`${question.question_number}. ${question.spanish_question}`"
              :options="getOptions(question.questionoption_set_info)"
            >
            </InputSelect> -->
            <div
              v-else-if="question.formfieldtype_info.name === 'single_selector'"
            >
              <b-form-group
                :label="`${question.question_number}. ${question.spanish_question}`"
              >
                <b-form-select
                  v-model="currentForm[question.id]"
                  :options="getOptions(question.questionoption_set_info)"
                  value-field="id"
                  text-field="text"
                  @change="changeSelect"
                />
              </b-form-group>
            </div>

            <CustomMultiselect
              v-else-if="question.formfieldtype_info.name === 'select_ciudad'"
              v-model="municipalitySelected"
              name="municipality"
              :label="`${question.question_number}. ${question.spanish_question}`"
              :custom-label="(o) => o.municipality_full_name"
              :options="
                getModelOptions(question.formfieldtype_info.model_related)
              "
            />

            <CustomMultiselect
              v-else-if="question.formfieldtype_info.name === 'select_cargo'"
              v-model="positionSelected"
              name="position"
              :label="`${question.question_number}. ${question.spanish_question}`"
              :custom-label="(p) => p.position_name"
              :options="
                getModelOptions(question.formfieldtype_info.model_related)
              "
            />

            <div v-else-if="
                            question.formfieldtype_info.html_element === 'input_date'
                          ">
                        <InputDate
                          v-model="currentForm[question.id]"
                          :name="question.id.toString()"
                          :label="`${
                            question.question_number > 0
                              ? `${question.question_number}.`
                              : ''
                          } ${question.spanish_question}`"
                          :options="getOptions(question.questionoption_set_info)"
                          :assessmentDate="assessment.date"
                        >
                        </InputDate>
            </div>
            <div v-else-if="question.formfieldtype_info.name === 'oculto'">
              <b-form-group
                :label="`${question.question_number}. ${question.spanish_question}`"
              >
                {{ inputHiddenString }}
              </b-form-group>
            </div>
          </div>
        </b-row>
      </b-container>
    </div>
  </div>
</template>